const getCategoryOptions = (categories, t) => {
  const placeholderText = t('popularKeywords.searchForm.categoryPlaceholder');
  const categoryPlaceholder = { label: placeholderText, value: '' };
  const options = categories.map(({ name }) => ({
    label: name,
    value: name,
  }));

  return [categoryPlaceholder].concat(options);
};

const getConditionOptions = (conditions, t) => {
  const placeholderText = t('popularKeywords.searchForm.conditionPlaceholder');
  const conditionPlaceholder = { label: placeholderText, value: '' };
  const options = conditions.map(({ attributeValueLabel, attributeValueId }) => ({
    label: `${attributeValueLabel}`,
    value: attributeValueId,
  }));

  return [conditionPlaceholder].concat(options);
};

const getDistanceOptions = (t) => {
  const placeholderText = t('popularKeywords.searchForm.distancePlaceholder');
  const distancePlaceholder = { label: placeholderText, value: '' };
  const options = [
    { label: '< 3km', value: '3000' },
    { label: '< 5km', value: '5000' },
    { label: '< 10km', value: '10000' },
    { label: '< 15km', value: '15000' },
    { label: '< 25km', value: '25000' },
    { label: '< 50km', value: '50000' },
    { label: '< 75km', value: '75000' },
  ];

  return [distancePlaceholder].concat(options);
};

export { getCategoryOptions, getConditionOptions, getDistanceOptions };
